<template>
  <div class="no-data-box">
    <img
      class="no-data"
      src="../../../assets/imgs/work-wx/common/icon-no-data.png"
      alt=""
    />
    <div class="no-data-text">{{ emptyText ? emptyText : '暂无数据' }}</div>
  </div>
</template>
<script>
export default {
  props: {
    emptyText: String,
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.no-data-box {
  width: 100%;
  .no-data {
    display: block;
    align-items: center;
    width: 120px;
    margin: 60px auto 20px;
    height: auto;
  }
  .no-data-text {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-bottom: 60px;
  }
}
</style>
